import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// 考勤统计
export function attendanceStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/throughGateRecord/attendance/barchartStatistics',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 考勤导出
export function attendanceRecordExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/throughGateRecord/export',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 5日缺勤学员导出
export const absenceExport = (data:any) => fetch({
  url: constants.API_MODULE_PATH.HEALTH + '/organize/web/throughGateRecord/noSigntList/export',
  method: 'post',
  data
})

// 缺勤统计
export function absenceStatic(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/absenceTrack/attendance/barchartStatistics',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 缺勤导出
export function absenceRecordExport(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/web/absenceTrack/export',
    method: 'post',
    data: {
      ...param
    }
  })
}
